// extracted by mini-css-extract-plugin
export default {"title":"Form_title__JyB1z","subTitle":"Form_subTitle__7rFqI","buttonText":"Form_buttonText__SA+q5","border":"Form_border__9uMFq"};